import React from 'react'
import { useTranslation } from 'react-i18next'
import Loading from '@/components/ui/Loading'
import { StudioCard } from '@/components/business/Studio'

const StudiosGrid = ({ studios, loading, error }) => {
  const { t } = useTranslation()

  if (loading) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="container section-padding">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('studio.grid.title')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('studio.grid.subtitle')}
            </p>
          </div>
          <div className="flex justify-center">
            <Loading />
          </div>
        </div>
      </section>
    )
  }

  if (error) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="container section-padding">
          <div className="text-center">
            <div className="text-6xl mb-4">😔</div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {t('common.error.title')}
            </h3>
            <p className="text-gray-600">
              {error || t('common.error.general')}
            </p>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="container section-padding">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('studio.grid.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('studio.grid.subtitle')}
          </p>
        </div>
        
        <div className="space-y-8 max-w-5xl mx-auto">
          {studios?.records?.map((studio) => (
            <StudioCard
              key={studio.orgId}
              studio={studio}
            />
          ))}
        </div>

        {(!studios || !studios.records || studios.records.length === 0) && (
          <div className="text-center py-12">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {t('studio.grid.noStudios.title')}
            </h3>
            <p className="text-gray-600">
              {t('studio.grid.noStudios.description')}
            </p>
          </div>
        )}
      </div>
    </section>
  )
}

export default StudiosGrid 